import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { authenticatedFetch } from '../utils/api';
import { API_ENDPOINTS } from '../config/api';
import { setBadgeCount } from '../utils/appBadge';
import classes from './NotificationBell.module.scss';

// Now just a trigger — the full notifications UI lives at /notifications.
// This keeps the bell tiny (40x40 round) and hoists dropdown-hostile mobile
// state onto a proper page.

const POLL_INTERVAL = 30_000;

export default function NotificationBell() {
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = useCallback(async () => {
    try {
      const res = await authenticatedFetch(API_ENDPOINTS.notifications.unreadCount);
      if (res.ok) {
        const data = await res.json();
        setUnreadCount(data.count);
      }
    } catch {}
  }, []);

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, POLL_INTERVAL);
    const onVisible = () => {
      if (document.visibilityState === 'visible') fetchUnreadCount();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [fetchUnreadCount]);

  useEffect(() => {
    setBadgeCount('notifications', unreadCount);
  }, [unreadCount]);

  return (
    <Link
      to="/notifications"
      className={`${classes.bell} ${unreadCount > 0 ? classes['bell--unread'] : ''}`}
      aria-label={unreadCount > 0 ? `Notifications (${unreadCount} unread)` : 'Notifications'}
      title="Notifications"
    >
      <span className={classes.bell__icon}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        {unreadCount > 0 && (
          <span className={classes.badge}>{unreadCount > 99 ? '99+' : unreadCount}</span>
        )}
      </span>
    </Link>
  );
}
